import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowRightAlt from '@mui/icons-material/ArrowRightAlt';
import { Divider, Grid, Paper } from '@mui/material';
import { differenceInCalendarMonths, format } from 'date-fns';
import { useTranslation } from '@zurich/common/hooks';
import { styled } from '../../../../utils';
import { Typography } from '../../../Typography';
import { MARKERS } from './DateRangePicker';
import DefinedRanges from './DefinedRanges';
import Month from './Month';
const HeaderGridStyled = styled(Grid, {
    label: 'materialui-daterange-picker-header',
})(() => ({
    padding: '20px 70px',
}));
const HeaderItemGridStyled = styled(Grid, {
    label: 'materialui-daterange-picker-headerItem',
})(() => ({
    flex: 1,
    textAlign: 'center',
}));
const DividerStyled = styled('div')(({ theme }) => ({
    borderLeft: `1px solid ${theme.palette.action.hover}`,
    marginBottom: 20,
}));
const Menu = (props) => {
    const { ranges, dateRange, minDate, maxDate, firstMonth, locale, setFirstMonth, secondMonth, setSecondMonth, setDateRange, helpers, handlers, } = props;
    const { startDate, endDate } = dateRange;
    const { t } = useTranslation();
    const canNavigateCloser = differenceInCalendarMonths(secondMonth, firstMonth) >= 2;
    const commonProps = {
        dateRange,
        minDate,
        maxDate,
        helpers,
        handlers,
    };
    return (_jsx(Paper, { elevation: 5, square: true, children: _jsxs(Grid, { container: true, direction: "row", wrap: "nowrap", children: [_jsxs(Grid, { children: [_jsxs(HeaderGridStyled, { container: true, alignItems: "center", children: [_jsx(HeaderItemGridStyled, { item: true, children: _jsx(Typography, { variant: "subtitle1", children: startDate
                                            ? format(startDate, 'PPP', { locale })
                                            : t('common:dates.start_date') }) }), _jsx(HeaderItemGridStyled, { item: true, children: _jsx(ArrowRightAlt, { color: "action" }) }), _jsx(HeaderItemGridStyled, { item: true, children: _jsx(Typography, { variant: "subtitle1", children: endDate
                                            ? format(endDate, 'PPP', { locale })
                                            : t('common:dates.end_date') }) })] }), _jsx(Divider, {}), _jsxs(Grid, { container: true, direction: "row", justifyContent: "center", wrap: "nowrap", children: [_jsx(Month, { ...commonProps, value: firstMonth, locale: locale, setValue: setFirstMonth, navState: [true, canNavigateCloser], marker: MARKERS.FIRST_MONTH }), _jsx(DividerStyled, {}), _jsx(Month, { ...commonProps, value: secondMonth, locale: locale, setValue: setSecondMonth, navState: [canNavigateCloser, true], marker: MARKERS.SECOND_MONTH })] })] }), _jsx(DividerStyled, {}), _jsx(Grid, { children: _jsx(DefinedRanges, { selectedRange: dateRange, ranges: ranges, setRange: setDateRange }) })] }) }));
};
export default Menu;
